export const TIMEOUT_MILLISECONDS = 1800000;
export const ONLINE_CHANNEL_KEY = 'F16192E6-3D89-4082-AFF2-DF396F33C221';
export const CLIENT_HEADER = 'kI2oJ1SVQh';


// WEBPACK FOOTER //
// ./src/constants/settings.js